module.exports = __webpack_public_path__ + "img/profile-picture.602ab390.png";